module.exports = __webpack_public_path__ + "static/media/product_settings_darkmode.c1d068aa.svg";